import React from 'react';
import NotFoundPage from '../pages/NotFound';
import { useServerInfo } from '../contexts/serverInfo';
import { Loader } from '@deque/cauldron-react';
import { useTranslation } from 'react-i18next';

interface Props {
  requireJazzband?: boolean;
  children: React.ReactNode;
}

/**
 * Block rendering the provided `children` unless the server has required capabilities
 */

const ServerCapabilities: React.FC<Props> = ({
  requireJazzband = false,
  children
}) => {
  const { t } = useTranslation();
  const { serverInfo, loading } = useServerInfo();
  const loaderRef = React.useRef<HTMLDivElement>(null);

  React.useEffect(() => {
    loaderRef.current?.focus();
  }, [loaderRef.current]);

  if (loading) {
    return <Loader label={t('Loading')} ref={loaderRef} tabIndex={-1} />;
  }

  if (requireJazzband && !serverInfo?.isJazzbandEnabled) {
    return <NotFoundPage />;
  }

  return <>{children}</>;
};

export default ServerCapabilities;
